import { Box, FlexColumn, OverflowText } from "designSystem/index";
import DojoView from "csi/page/DojoView";
import { observer } from "mobx-react-lite";
import React from "react";
import { usePullFromBOMStoreContext } from "./PullFromBOMStore";


export const PullFromTable = observer(() => {
	const store = usePullFromBOMStoreContext();
	const { master, tableNodeType, tableSubTitleRes, tableViewId, viewParams } = store;

	return (
		<FlexColumn p={5}>
			<Box mb={1.5}>
				<OverflowText res={tableSubTitleRes} />
			</Box>
			<Box growNoOverflow>
				<DojoView 
					fullHeight 
					nodeUrl={master.$URL} 
					viewId={tableViewId} 
					viewNodeType={tableNodeType}
					viewParams={viewParams}
				/>
			</Box>
		</FlexColumn>
	);
});

